// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2bu3x","row":"Node_row__14HP6","label":"Node_label__2i_5k","footer":"Node_footer__1key1"};